import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            分类索引
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型探索海量影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group flex flex-col items-center p-5 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300/40 hover:bg-background-100 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100/70 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                {item.count.toLocaleString()}部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}